import { render, staticRenderFns } from "./AddSalesInvoice.vue?vue&type=template&id=615c6f21"
import script from "./AddSalesInvoice.vue?vue&type=script&lang=ts"
export * from "./AddSalesInvoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports